import { Component } from '@angular/core';

@Component({
  selector: 'uni-form-steps',
  templateUrl: './uni-form-steps.component.html',
  styleUrls: ['./uni-form-steps.component.scss']
})
export class UniFormStepsComponent {}
